import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router";

import { handleChange as handleChangeAction } from "../../actions/handleChangeAction";
import GrunndataFilter from "./GrunndataFilter";

export default function GrunndataFilterContainer() {
  const location = useLocation();
  const grunndataFilterForm = useSelector(
    (state) => state.forms.grunndataFilterForm,
  );
  const dispatch = useDispatch();

  const handleChange = (name, value) =>
    dispatch(handleChangeAction("GRUNNDATA_FILTER_FORM", name, value));

  return (
    <GrunndataFilter
      location={location}
      grunndataFilterForm={grunndataFilterForm}
      handleChange={handleChange}
    />
  );
}
